export const mockData1 = [
  {
    id: 1,
    label: "学科门类",
    children: [
      { id: 10, label: "全部", active: true },
      { id: 11, label: "综合", active: false },
      { id: 12, label: "法学", active: false }
    ],
    active: true
  },
  {
    id: 2,
    label: "资源类型",
    children: [
      { id: 20, label: "全部", active: true },
      { id: 21, label: "古籍", active: false },
      { id: 22, label: "期刊", active: false },
      { id: 23, label: "图书", active: false },
      { id: 23, label: "学位论文", active: false },
      { id: 25, label: "会议论文", active: false },
      { id: 26, label: "法律法规", active: false },
      { id: 27, label: "案例", active: false },
      { id: 28, label: "报纸", active: false },
      { id: 29, label: "年鉴", active: false },
      { id: 30, label: "考试培训类", active: false },
      { id: 31, label: "音视频", active: false },
      { id: 32, label: "专题库", active: false },
      { id: 33, label: "方志", active: false },
      { id: 34, label: "音乐", active: false },
      { id: 35, label: "检索工具", active: false },
      { id: 36, label: "信息咨讯", active: false },
      { id: 37, label: "科技成果", active: false },
      { id: 38, label: "专利", active: false },
      { id: 39, label: "标准", active: false },
      { id: 40, label: "艺术", active: false },
      { id: 41, label: "工程管理", active: false },
      { id: 42, label: "图书情报", active: false },
      { id: 43, label: "旅游管理", active: false },
      { id: 44, label: "会计", active: false },
      { id: 45, label: "公共管理", active: false },
      { id: 47, label: "军事", active: false },
      { id: 48, label: "其他", active: false },
      { id: 49, label: "其他", active: false }
    ]
  },
  {
    id: 3,
    label: "语言",
    children: [
      { id: 30, label: "全部", active: true },
      { id: 31, label: "外文", active: false },
      { id: 32, label: "中文", active: false }
    ]
  }
]

export const mockData2 = [
  {
    label: "综合1级",
    id: "1",
    active: false,
    children: [
      {
        label: "综合2级1",
        id: "11",
        children: [
          {
            label: "综合3级1",
            id: "111",
            children: [
              {
                label: "综合4级1",
                id: "1111",
                children: [
                  {
                    label: "综合5级1"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        label: "综合2级2",
        id: "12",
        children: [
          {
            label: "综合2级1",
            id: "121"
          }
        ]
      },
      {
        label: "综合2级3",
        id: "13",
        children: []
      },
      {
        label: "综合2级4",
        id: "14"
      },
      {
        label: "综合2级5",
        id: "15"
      },
      {
        label: "综合2级6",
        id: "16"
      }
    ]
  },
  {
    label: "法学",
    id: "2",
    active: false,
    children: [
      {
        label: "法学一",
        id: "21"
      },
      {
        label: "法学二",
        id: "22"
      }
    ]
  },
  {
    label: "物理学",
    id: "3",
    active: false,
    children: [
      {
        label: "物理学一",
        id: "31"
      },
      {
        label: "物理学二",
        id: "33"
      }
    ]
  },
  {
    label: "生物",
    id: "4"
  },
  {
    label: "数学",
    id: "5"
  },
  {
    label: "概率论",
    id: "7"
  },
  {
    label: "微积分",
    id: "8"
  },
  {
    label: "微电子",
    id: "9"
  }
]
